import React, { useEffect, useState } from "react";
import PageTitle from "../../../jsx/layouts/PageTitle";

const initialForm = {
  top_text: "",
  heading: "",
  description: "",
  item1_title: "",
  item1_description: "",
  item2_title: "",
  item2_description: "",
};

const WhyChooseDashboard = () => {
  const [whyChooseData, setWhyChooseData] = useState(null);
  const [form, setForm] = useState(initialForm);
  const [editingId, setEditingId] = useState(null);
  const [mainImage, setMainImage] = useState(null);

  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  useEffect(() => {
    fetchWhyChoose();
  }, []);

  const fetchWhyChoose = async () => {
    try {
      const res = await fetch("https://admin.drgargevascular.com/backend/why-choose");
      const data = await res.json();

      if (data && data.id) {
        setWhyChooseData(data);
        setEditingId(data.id);

        setForm({
          top_text: data.top_text || "",
          heading: data.heading || "",
          description: data.description || "",
          item1_title: data.item1_title || "",
          item1_description: data.item1_description || "",
          item2_title: data.item2_title || "",
          item2_description: data.item2_description || "",
        });
      } else {
        setWhyChooseData(null);
        setEditingId(null);
        setForm(initialForm);
      }
    } catch (error) {
      console.error("Error fetching why choose:", error);
    }
  };

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const handleFileChange = (e) => {
    setMainImage(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();

    Object.keys(form).forEach((key) => {
      formData.append(key, form[key]);
    });

    if (mainImage) {
      formData.append("main_image", mainImage);
    }

    try {
      const url = editingId
        ? `https://admin.drgargevascular.com/backend/why-choose/${editingId}`
        : "https://admin.drgargevascular.com/backend/why-choose";

      const method = editingId ? "PUT" : "POST";

      const res = await fetch(url, {
        method,
        body: formData,
      });

      if (!res.ok) throw new Error("Failed request");

      setMessage(
        editingId
          ? "Why Choose section updated successfully!"
          : "Why Choose section added successfully!"
      );
      setMessageType("success");

      fetchWhyChoose();

      setTimeout(() => {
        setMessage("");
        setMessageType("");
      }, 4000);
    } catch (error) {
      console.error(error);
      setMessage("Something went wrong. Please try again.");
      setMessageType("error");

      setTimeout(() => {
        setMessage("");
        setMessageType("");
      }, 4000);
    }
  };

  return (
    <>
      <PageTitle activeMenu="Why Choose Us" motherMenu="Dashboard" />

      <div className="row">
        <div className="col-xl-12">
          <div className="card shadow-sm border-0">
            <div className="card-header bg-white border-bottom">
              <h4 className="mb-0 fw-bold">
                {editingId ? "Edit Why Choose Section" : "Add Why Choose Section"}
              </h4>
            </div>

            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label className="form-label fw-bold">Top Text</label>
                    <input
                      type="text"
                      name="top_text"
                      className="form-control"
                      value={form.top_text}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label fw-bold">Heading</label>
                    <input
                      type="text"
                      name="heading"
                      className="form-control"
                      value={form.heading}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-md-12 mb-3">
                    <label className="form-label fw-bold">Description</label>
                    <textarea
                      name="description"
                      className="form-control"
                      rows="4"
                      value={form.description}
                      onChange={handleChange}
                    ></textarea>
                  </div>

                  <div className="col-md-12 mb-3">
                    <label className="form-label fw-bold">Main Image</label>
                    <input
                      type="file"
                      name="main_image"
                      className="form-control"
                      onChange={handleFileChange}
                    />
                  </div>

                  <div className="col-12 mt-3 mb-2">
                    <h5 className="border-bottom pb-2 fw-bold">Feature Box 1</h5>
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label fw-bold">Feature 1 Title</label>
                    <input
                      type="text"
                      name="item1_title"
                      className="form-control"
                      value={form.item1_title}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label fw-bold">Feature 1 Description</label>
                    <textarea
                      name="item1_description"
                      className="form-control"
                      rows="3"
                      value={form.item1_description}
                      onChange={handleChange}
                    ></textarea>
                  </div>

                  <div className="col-12 mt-3 mb-2">
                    <h5 className="border-bottom pb-2 fw-bold">Feature Box 2</h5>
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label fw-bold">Feature 2 Title</label>
                    <input
                      type="text"
                      name="item2_title"
                      className="form-control"
                      value={form.item2_title}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label fw-bold">Feature 2 Description</label>
                    <textarea
                      name="item2_description"
                      className="form-control"
                      rows="3"
                      value={form.item2_description}
                      onChange={handleChange}
                    ></textarea>
                  </div>

                  {message && (
                    <div className="col-md-12">
                      <div
                        className={`alert ${
                          messageType === "success"
                            ? "alert-success"
                            : "alert-danger"
                        }`}
                        style={{
                          fontSize: "14px",
                          borderRadius: "8px",
                          padding: "10px 15px",
                        }}
                      >
                        {message}
                      </div>
                    </div>
                  )}

                  <div className="col-md-12 mt-2">
                    <button className="btn btn-primary px-4">
                      {editingId ? "Update Why Choose Section" : "Save Why Choose Section"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>

        {/* PREVIEW */}
        <div className="col-xl-12 mt-4">
          <div className="card shadow-sm border-0">
            <div className="card-header bg-white border-bottom">
              <h4 className="mb-0 fw-bold">Current Preview</h4>
            </div>

            <div className="card-body">
              {whyChooseData ? (
                <div className="row align-items-center">
                  <div className="col-lg-4">
                    <img
                      src={
                        whyChooseData.main_image
                          ? `https://admin.drgargevascular.com/backend${whyChooseData.main_image}`
                          : ""
                      }
                      alt="why choose"
                      style={{
                        width: "100%",
                        borderRadius: "12px",
                        objectFit: "cover",
                        maxHeight: "280px",
                      }}
                    />
                  </div>

                  <div className="col-lg-8">
                    <span className="text-danger fw-bold">
                      {whyChooseData.top_text}
                    </span>
                    <h2 className="mt-2">{whyChooseData.heading}</h2>
                    <p className="text-muted">{whyChooseData.description}</p>

                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <div className="border rounded p-3 h-100">
                          <h5>{whyChooseData.item1_title}</h5>
                          <p className="mb-0 text-muted">
                            {whyChooseData.item1_description}
                          </p>
                        </div>
                      </div>

                      <div className="col-md-6 mb-3">
                        <div className="border rounded p-3 h-100">
                          <h5>{whyChooseData.item2_title}</h5>
                          <p className="mb-0 text-muted">
                            {whyChooseData.item2_description}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="text-center py-5 text-muted">
                  No Why Choose section data found.
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default WhyChooseDashboard;